export default __webpack_public_path__ + "static/media/analytics.a4d294d8.svg";